module.exports = __webpack_public_path__ + "static/media/headerimg.fc044539.svg";